import { Component, Vue } from 'vue-property-decorator';
import { Getter } from '@/decorators';
import { clearToken, fetchImpersonate, fetchUsers, isImpersonating, setToken, syncUsers } from '@/services';
import { TableHeaderColumns, UserDTO } from '@/models';
import { PAGE_NAMES } from '@/constants';
import Avatar from '@/components/common/avatar/Avatar.vue';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';
import SearchInput from '@/components/common/search-input/SearchInput.vue';
import Pagination from '@/components/common/pagination/Pagination.vue';

@Component({
  components: {
    SearchInput,
    InlineLoader,
    Avatar,
    Pagination
  }
})
export default class UserManagement extends Vue {
  @Getter('app/currentUser') currentUser: UserDTO;

  private isUserListFetching = true;
  private headers: TableHeaderColumns = [
    {
      text: 'Employee ID',
      align: 'start',
      value: 'code'
    },
    { text: 'Employee Name', value: 'fullName' },
    { text: 'Email', value: 'email' },
    { text: 'Org Name', value: 'orgName' },
    { value: 'impersonate', sortable: false }
  ];
  private admins: UserDTO[] = [];
  private users: UserDTO[] = [];
  private search = '';
  private itemsPerPage = 10;
  private page = 1;
  private pageCount = 0;
  private perPageChoices = [
    { text: '5', value: 5 },
    { text: '10', value: 10 },
    { text: 'All', value: -1 },
  ];

  async syncUser(): Promise<void> {
    this.isUserListFetching = true;
    await syncUsers().then(payload => {
      this.users = payload.data;
    });
    this.isUserListFetching = false;
  }

  async mounted(): Promise<void> {
    await fetchUsers().then(payload => {
      this.users = payload.data;
    }).finally(() => {
      this.isUserListFetching = false;
    });
  }

  get isImpersonate(): boolean {
    return isImpersonating();
  }

  async impersonate(id: string): Promise<void> {
    const { data } = await fetchImpersonate(id);
    clearToken();
    setToken(data);
    this.$router.push({ name: PAGE_NAMES.HOME }, () => { location.reload(); });
  }

  isCurrentUser(user: UserDTO): boolean {
    return this.currentUser.id === user.id;
  }

  onSearch(searchText: string): void {
    this.search = searchText;
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  onItemsPerPageChange(itemsPerPage: number): void {
    this.itemsPerPage = itemsPerPage;
  }
}
